export const applyHeatingSystemSSRRules = (switchInfo, heatingSys) => {
  if (heatingSys !== 'tgs') return switchInfo;

  return {
    ...switchInfo,
    selectedSSR: [],
    ssrRating: '',
  };
};

